import { render, staticRenderFns } from "./client-search.vue?vue&type=template&id=6446c3b6&scoped=true&"
import script from "./client-search.vue?vue&type=script&lang=js&"
export * from "./client-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446c3b6",
  null
  
)

export default component.exports